import { TimeLogType, TimelogBillable } from './../../entities/time_log/TimeLogResponse';
import { Endpoint } from '../endpoint';

import { TimeLogResponse, ManualTimeLogRequest, TimeLogId, TimeLogFilterType } from '@business/entities/time_log';
import { UserId } from '@business/entities/account';
import { SupportHourInfo, OrgId, TimeTrackingInfoResponse } from '@business/entities/organization';
import { R } from '@core/utils/r';
import { TimelogBillableFormData } from '@modules/common/TimeLog/TimelogBillableModel/TimelogBillableModel';

/**
 * Support Channel API
 */
export function fetchTimeLogs(type: string, objectId: string) {
  return Endpoint.get<TimeLogResponse[]>(`@gc/time-log`, { params: { type, objectId } });
}

export function fetchOpenTimeLogs(filterType: TimeLogFilterType, filterId: string) {
  return Endpoint.get<TimeLogResponse[]>(`@gc/time-log/open`, { params: { filterType, filterId } });
}

export function createManualTime(type: string, objectId: string, data: ManualTimeLogRequest, parentId?: string, parentType?: TimeLogType) {
  return Endpoint.post<TimeLogResponse>(`@gc/time-log/manual/${type}/${objectId}`, { data: { ...data, parentId, parentType } });
}

export function updateManualTime(id: TimeLogId, data: ManualTimeLogRequest) {
  return Endpoint.patch<TimeLogResponse>(`@gc/time-log/manual/${id}`, { data });
}

export function startTimeLog(
  type: string,
  objectId: string,
  extraInfo?: any,
  parentId?: string,
  parentType?: TimeLogType,
  billable?: TimelogBillable,
) {
  return Endpoint.post<TimeLogResponse>(`@gc/time-log/${type}/${objectId}`, {
    data: R.objectCompact({ extraInfo, parentId: parentId, parentType, billable }),
  });
}

export function stopTimeLog(id: TimeLogId, data?: TimeTrackingInfoResponse) {
  return Endpoint.patch<TimeLogResponse>(`@gc/time-log/stop/${id}`, { data });
}

// export function stopTimeLog(id: TimeLogId, data?: TimeTrackingInfoResponse) {
//   return Endpoint.patch<TimeMaterialResponse>(`@gc/time-log/stop/${id}`, { data });
// }

export function deleteTimeLog(id: TimeLogId) {
  return Endpoint.delete<void>(`@gc/time-log/${id}`);
}

export function fetchSingleTimelog(id: TimeLogId) {
  return Endpoint.get<TimeLogResponse>(`@gc/time-log/timelog/${id}`);
}

export function getSupportHourInfo(orgId: OrgId) {
  return Endpoint.get<SupportHourInfo>(`@gc/organizations/support-hour-info/${orgId}`);
}

export function fetchActiveModuleTime(timeLogType: TimeLogType, filterId?: string) {
  return Endpoint.get<TimeLogResponse[]>(`@gc/time-log/active-module-time`, { params: { timeLogType, filterId } });
}

export function fetchActiveTimeTrackings(timeLogType: TimeLogType, filterId?: string) {
  return Endpoint.get<TimeLogResponse[]>(`@gc/time-log/active-time-trackings`, { params: { timeLogType, filterId } });
}

export function stopTimer() {
  return Endpoint.post<TimeLogResponse[]>(`@gc/time-log/stop`);
}
